<template>
  <div id="components-layout-demo-basic" style="background: #ececec">
    <a-layout>
      <a-layout-header>课后服务开放平台</a-layout-header>
    </a-layout>
    <div v-if="!state.readOnly" class="auditChoice">
      <span class="auditChoice-title">资料审核</span>
      <div style="display: inline-block">
        <a
          @click="choice(true)"
          class="auditChoice-choise"
          style="margin-right: 40px"
        >
          <img src="/icon/success.png" alt="" /> 通过</a
        >
        <a @click="choice(false)" class="auditChoice-choise"
          ><img src="/icon/close-circle-fill.png" alt="" /> 不通过</a
        >
      </div>
    </div>
    <div
      style="
        background: #ececec;
        padding: 80px;
      "
    >
      <a-card :bordered="false">
        <!-- 个人 -->
        <div class="four-one">
          <a-form :form="form" style="margin: 30px 0 0 39px">
            <a-row :gutter="24">
              <!-- 基本资料 -->
              <div class="basics">
                <div class="section4">
                  <div class="mod4"></div>
                  <span class="txt1">基本资料</span>
                  <div class="record">
                    <div
                      class="value ml30 record1"
                      :class="{
                        'value-rejected': state.status == '2',
                        'value-resolve': state.status == '1',
                        'value-examine':
                          state.status == '4' ||
                          state.status == '5' ||
                          state.status == '0',
                      }"
                    >
                      {{
                        state.status == '0'
                          ? '待审核'
                          : state.status == '1'
                          ? '审核通过'
                          : state.status == '2'
                          ? '审核不通过'
                          : state.status == '4'
                          ? '初审通过'
                          : '复审通过'
                      }}
                    </div>

                    <div class="record2">
                      <a @click="record">历史审核记录</a>
                    </div>
                  </div>
                </div>
                <a-col :span="11" style="margin: 20px 0">
                  <span class="title">姓名</span>
                  <span> {{ state.nickname }} </span>
                </a-col>
                <a-col :span="11" style="margin: 20px 0">
                  <span class="title">性别</span>
                  <span>{{ state.genderText }} </span>
                </a-col>
                <a-col :span="11" style="margin: 20px 0">
                  <span class="title">主要联络手机号</span>
                  <span> {{ state.mobile }} </span>
                </a-col>
                <a-col :span="11" style="margin: 20px 0">
                  <span class="title">身份证号</span>
                  <span> {{ state.cardNo }} </span>
                </a-col>
                <a-col :span="11" style="margin: 20px 0">
                  <span class="title">银行卡号</span>
                  <span> {{ state.bankCardNo }} </span>
                </a-col>
                <a-col :span="11" style="margin: 20px 0">
                  <span class="title">开户行</span>
                  <span> {{ state.bankName }} </span>
                </a-col>
                <a-col :span="11" style="margin: 20px 0">
                  <span class="title">执教年限</span>
                  <span> {{ state.teachingYears }} </span>
                </a-col>
                <a-col :span="11" style="margin: 20px 0">
                  <span class="title">授课方向</span>
                  <span> {{ state.applyCourseType }} </span>
                </a-col>

                <a-col :span="24" style="margin: 20px 0">
                  <div class="title">个人简介</div>
                  <a-form-item>
                    {{ state.intro }}
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item :required="true">
                    <div class="title">正面免冠照片（2寸）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_fullFaced"
                      class="fullFaced"
                      ref="protraitPhotoUrl"
                      :isSingle="false"
                      :maxlength="1"
                      :maxFileSize="204800"
                      :imageMatchHeight="626"
                      :imageMatchWidth="413"
                      messageTitle="正面免冠照片"
                      :sourceFileList="sourceFileList_fullFaced"
                    ></c-upload>
                    <!-- 限制照片为两寸  :twoInches="true"-->
                    <div class="remark">
                      符合宽高413×626像素200KB以内，支持jpeg,jpg,png
                    </div>
                  </a-form-item>
                </a-col>

                <a-col :span="8">
                  <!-- --------------------------------------------------------------------- -->
                  <a-form-item :required="true">
                    <div class="title">头像</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_headPortrait"
                      class="headPortrait"
                      :isSingle="false"
                      :maxlength="1"
                      :maxFileSize="1048576"
                      ref="avatarUrl"
                      :sourceFileList="sourceFileList_avatarUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <!-- --------------------------------------------------------------------- -->
                  <a-form-item :required="true">
                    <div class="title">8分钟说课视频</div>
                    <div v-if="reqDesc.talkingVideoUrl">
                      <video
                        style="height: 150px; width: 100%"
                        controls="controls"
                        muted="true"
                        :src="reqDesc.talkingVideoUrl"
                      ></video>
                    </div>
                    <c-upload
                      :disabled="true"
                      v-if="sourceFileListTalkingVideoUrl.length == 0"
                      accept="video/*"
                      ossType="institution"
                      ref="uploadVideo"
                      :maxlength="1"
                      :maxFileSize="419430400"
                      :showUploadList="false"
                      messageTitle="说课视频"
                      :isSingle="false"
                      @uploadSuccess="uploadVideo"
                      :sourceFileList="sourceFileListTalkingVideoUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <div class="section18"></div>
                </a-col>
              </div>
              <!-- 学历信息 -->
              <div class="information">
                <a-col :span="24">
                  <div class="section4">
                    <div class="mod4"></div>
                    <span class="txt1">学历信息</span>
                  </div>
                </a-col>
                <a-col :span="24">
                  <div class="education">学历及毕业院校(选填)</div>
                </a-col>
                <div
                  v-show="addCount != -1"
                  class="xueli"
                  v-for="(item, index) in state.degreeCertificatList"
                  :key="index"
                >
                  <a-col :span="18" v-if="index !== 0">
                    <div class="outer9"></div>
                  </a-col>
                  <a-col :span="7">
                    <a-form-item>
                      <a-select
                        :disabled="true"
                        v-decorator="[
                          `degreeCertificatList[${index}].eduBackground`,
                          {
                            rules: [{ message: '请选择您的学历' }],
                            initialValue: item.eduBackground || undefined,
                          },
                        ]"
                        style="width: 150px"
                        placeholder="请选择您的学历"
                      >
                        <a-select-option
                          v-for="(item, index) in educationSelect"
                          :key="index"
                          :value="item"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="13">
                    <a-form-item>
                      <a-input
                        :disabled="true"
                        v-decorator="[
                          `degreeCertificatList[${index}].text`,
                          {
                            rules: [{ message: '请输入您的毕业院校' }],
                            initialValue: item.text,
                          },
                        ]"
                        placeholder="请输入毕业院校"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="7" style="height: 25px">
                    <a-form-item :required="true">
                      <div class="card">学历证</div>
                      <c-upload
                        :disabled="true"
                        accept="image/*"
                        @uploadSuccess="uploadSuccess_diploma($event, index)"
                        class="diploma"
                        :isSingle="false"
                        :maxlength="1"
                        ref="diploma"
                        :sourceFileList="item.photoUrl2List"
                      ></c-upload>
                    </a-form-item>
                  </a-col>
                  <a-col :span="13">
                    <a-form-item :required="true">
                      <div class="card">学位证</div>
                      <c-upload
                        :disabled="true"
                        accept="image/*"
                        @uploadSuccess="uploadSuccess_photoUrl($event, index)"
                        class="diploma"
                        :isSingle="false"
                        :maxlength="1"
                        ref="photoUrl"
                        :sourceFileList="item.photoUrlList"
                      ></c-upload>
                    </a-form-item>
                  </a-col>
                </div>

                <a-col :span="24">
                  <div class="section18"></div>
                </a-col>
              </div>
              <!-- 其他资料 -->

              <div class="attachments">
                <a-col :span="24">
                  <div class="section4">
                    <div class="mod4"></div>
                    <span class="txt1">其他资料</span>
                  </div>
                </a-col>
                <a-col :span="9">
                  <a-form-item :required="true">
                    <div class="card">身份证（正面）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      :isSingle="false"
                      :maxlength="1"
                      class="frontIDCard"
                      @uploadSuccess="uploadSuccess_frontIDCard"
                      ref="cardFrontUrl"
                      :sourceFileList="sourceFileList_cardFrontUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item :required="true">
                    <div class="card">身份证（反面）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_backIDCard"
                      class="backIDCard"
                      :isSingle="false"
                      :maxlength="1"
                      ref="cardBackUrl"
                      :sourceFileList="sourceFileList_cardBackUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item>
                    <div class="card">健康证明（选填,至多上传5张）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_health"
                      class="proveHealth"
                      :isSingle="false"
                      :maxlength="5"
                      :sourceFileList="reqDesc.healthCertificateUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item>
                    <div class="card">老师资质证书（选填,至多上传5张）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_teacher"
                      class="proveHealth"
                      :isSingle="false"
                      :maxlength="5"
                      :sourceFileList="reqDesc.credentialInfoUrlList"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="10">
                  <a-form-item>
                    <div class="card">无犯罪记录证明（选填）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_criminal"
                      class="prove"
                      :isSingle="false"
                      :maxlength="1"
                      :sourceFileList="sourceFileList_noCriminalUrl"
                    ></c-upload>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item>
                    <div class="card">从业经验（选填,至多上传5张）</div>
                    <c-upload
                      :disabled="true"
                      accept="image/*"
                      @uploadSuccess="uploadSuccess_experience"
                      class="proveHealth"
                      :isSingle="false"
                      :maxlength="5"
                      :sourceFileList="reqDesc.experience"
                    ></c-upload>
                  </a-form-item>
                </a-col>
              </div>
            </a-row>
          </a-form>
        </div>
      </a-card>
      <a-modal width="40%" :maskClosable="false" centered v-model="visible">
        <template slot="footer">
          <div style="text-align: center">
            <a-button
              v-if="passWord != '审核不通过'"
              class="modalButton"
              style="background-color: #68cc2e"
              @click="isPass('yes')"
            >
              确认审核通过
            </a-button>
            <a-button
              @click="isPass('no')"
              v-else
              class="modalButton"
              style="background-color: red"
            >
              确认审核不通过
            </a-button>
          </div>
        </template>
        <div style="text-align: center; margin-top: 10px">
          <div>
            <div style="display: inline-block">
              <img src="/icon/orange-dot.png" alt="" style="width: 30px" />
              <p class="result">
                {{ state.statusText }}
              </p>
            </div>
            <div style="display: inline-block; vertical-align: top">
              <img src="/icon/long-arrows.png" alt="" style="width: 150px" />
              <p></p>
            </div>
            <div style="display: inline-block">
              <img :src="passIcon" alt="" style="width: 30px" />
              <p class="result">{{ passWord }}</p>
            </div>
          </div>
          <div style="margin: 15px 0">
            {{ passWord }}，{{ state.nickname }}老师的审核状态从“{{
              state.statusText
            }}”更改为“{{ passWord }}”
          </div>
          <p class="audit">审核人</p>
          <a-input
            :maxLength="20"
            v-model="params.reviewerName"
            placeholder="请输入审核人"
          ></a-input>
          <p class="audit">审核意见</p>
          <a-textarea
            type="text"
            class="textarea-input"
            placeholder="请输入审核意见 , 多行输入"
            :maxLength="250"
            v-model="params.failReason"
          />
          <div style="text-align: left; margin: 20px 0">
            <p class="ideaImg">审核附件</p>
            <c-progress
              class="cupload"
              name="上传附件"
              ref="lessonResource"
              tips="请上传图片/PDF格式/zip文件"
              accept="image/*,.pdf,.zip,.rar,.7z,.gzip"
              :isDisabled="isProgress"
              :keyValue="key"
              :videoObj="teacherLesson.lessonResource"
              @uploadSuccess="uploadSuccess_attachment"
            ></c-progress>
            <!-- <span class="upload">请上传图片/PDF格式/zip文件</span> -->
          </div>
        </div>
      </a-modal>

      <a-modal
        width="40%"
        :maskClosable="false"
        centered
        v-model="recordVisible"
        :footer="null"
      >
        <div class="in-item">
          <!-- <div class="key">课程审核<span class="status-show">初审通过</span></div> -->
          <div class="key">
            审核状态
            <span
              class="value ml30"
              :class="{
                'value-rejected': state.status == '2',
                'value-resolve': state.status == '1',
                'value-examine':
                  state.status == '4' ||
                  state.status == '5' ||
                  state.status == '0',
              }"
              >{{
                state.status == '0'
                  ? '待审核'
                  : state.status == '1'
                  ? '审核通过'
                  : state.status == '2'
                  ? '审核不通过'
                  : state.status == '4'
                  ? '初审通过'
                  : '复审通过'
              }}</span
            >
          </div>
          <div class="value">
            <ul class="process">
              <li
                class="process-item"
                v-for="item in checkOperateLogArr"
                :key="item.id"
              >
                <span class="operate">{{ item.operateLog }}</span>
                <span
                  :class="[
                    item.stateAfter == 1
                      ? 'exa1'
                      : item.stateAfter == 2
                      ? 'exa2'
                      : 'exa3',
                  ]"
                >
                  {{ item.stateAfterText }}
                </span>
                <div class="comment" v-if="item.userComment">
                  审核意见：{{ item.userComment }}
                </div>
                <!-- <a
                    v-if="item.attachmentUrl"
                    :download="item.attachmentUrl"
                  >
                    下载附件</a
                  > -->
                <div class="download-btn" v-if="item.attachmentUrl">
                  <span>相关附件：{{ item.fileName }}</span>
                  <a
                    :href="rootUrl + item.attachmentUrl"
                    :download="rootUrl + item.attachmentUrl"
                    target="_blank"
                  >
                    下载</a
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import bureau from '../../api/bureau'
import user from '../../api/user'
import teacher from '../../api/teacher'
import CProgress from '../../components/CProgress'
import CUpload from '../../components/CUpload'
export default {
  components: {
    CUpload,
    CProgress,
  },
  data() {
    return {
      isProgress: false,
      teacherLesson: [], // 上传附件
      downloadFileUrl: '', // 附件地址
      attachmentUrl: '', // 上传附件url
      visible: false,
      recordVisible: false,
      teacherDetail: { status: '5' },
      checkOperateLogArr: [],
      passIcon: '',
      passWord: '',
      form: this.$form.createForm(this),
      state: {
        gender: 1,
        intro: '',
        ...this.$store.state.register.form,
        degreeCertificatList: [],
        auditFailed: true,
      },
      reqDesc: {
        protraitPhotoUrl: '',
        cardFrontUrl: '',
        cardBackUrl: '',
        avatarUrl: '',
        healthCertificateUrl: [],
        noCriminalUrl: '',
        credentialInfoUrlList: [],
        experience: [],
        talkingVideoUrl: '',
      },
      educationSelect: ['专科', '本科', '研究生', '博士', '其他'],
      addCount: -1,
      sourceFileList: [],
      bureauId: '',
      loading: false,
      saveloading: false,
      // status: '',
      sourceFileList_cardBackUrl: [],
      sourceFileList_cardFrontUrl: [],
      sourceFileList_fullFaced: [],
      sourceFileList_avatarUrl: [],
      sourceFileList_noCriminalUrl: [],
      sourceFileListTalkingVideoUrl: [],
      key: '',
      params: {},
      fileName: '', // 附件名称
      rootUrl: '', // 基地址
    }
  },
  created() {
    this.key = location.search.split('?key=')[1]
    console.log('this.key', this.key)
    this.getFlexibleTeacherInfo()
    this.getHostUrl()
  },
  mounted() {},
  methods: {
    getHostUrl() {
      this.rootUrl = globalConfig.rootUrl + '/api/pcWeb/aliyun/getFile?url='
    },
    // 下载文件回调
    uploadSuccess_attachment(backIndex) {
      console.log('111')
      //只有obj存在，新增，反之删除
      const lessonResource = this.$refs.lessonResource.successUpload_data()

      this.$set(this.teacherLesson, 'lessonResource', lessonResource)
      console.log('lessonResource', lessonResource)
      if (lessonResource[0]) {
        this.params.attachmentUrl = lessonResource[0].fileUrl
        this.params.fileName = lessonResource[0].fileName
        this.isProgress = true
      } else {
        this.params.attachmentUrl = ''
        this.isProgress = false
      }
    },
    isPass(type) {
      if (!this.params.reviewerName) {
        this.$message.error('请填写审核人')
        return
      }
      let newStatus
      if (type == 'yes') {
        if (this.state.status == '0') {
          newStatus = 4
        } else if (this.state.status == '4') {
          newStatus = 5
        } else if (this.state.status == '5') {
          newStatus = 1
        }
      } else if (type == 'no') {
        if (!this.params.failReason) {
          this.$message.error('请填写审核意见')
          return
        }
        newStatus = 2
      }
      if (this.params.failReason) {
        // 过滤表情
        this.params.failReason = this.params.failReason.replace(
          /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,
          ''
        )
      }

      this.params = {
        ...this.params,
        oldStatus: this.state.status,
        status: newStatus,
      }
      console.log('this.params', this.params)

      teacher
        .updateFlexibleTeacherStatus(this.key, this.params)
        .then((res) => {
          console.log('res', res)
        })
        .finally((res) => {
          this.visible = false
          this.params = {}
          this.getFlexibleTeacherInfo()
        })
    },
    getFlexibleTeacherInfo() {
      teacher.getFlexibleTeacherInfo(this.key).then((res) => {
        console.log('res', res)
        this.state = res.data
        this.dataBack()
      })
    },
    record() {
      teacher.getCheckOperateLogFlexible(this.key).then((res) => {
        res.data.checkOperateLogDos.forEach((v) => {
          if (v.attachmentUrl) {
            let fileArr = v.attachmentUrl.split("_");
            v.attachmentUrl = encodeURIComponent(v.attachmentUrl);
            if (fileArr.length > 2) {
              let temp = "";
              fileArr.shift();
              temp = fileArr.join("_");
              v.fileName = temp;
            } else if (fileArr.length == 2) {
              v.fileName = fileArr[1];
            }

            if (v.fileName == undefined) {
              v.fileName = "无附件名";
            }
          }
        });
        this.checkOperateLogArr = res.data.checkOperateLogDos
        console.log('res', res)
      })
      this.recordVisible = true
    },
    choice(type) {
      if (type) {
        if (this.state.status == 0) {
          this.passWord = '初审通过'
          this.passIcon = '/icon/orange-dot.png'
        } else if (this.state.status == 4) {
          this.passIcon = '/icon/orange-dot.png'
          this.passWord = '复审通过'
        } else if (this.state.status == 5) {
          this.passIcon = '/icon/green-dot.png'
          this.passWord = '审核通过'
        }
      } else {
        this.passIcon = '/icon/red-dot.png'
        this.passWord = '审核不通过'
      }
      teacher.teaTeacherGetOssToken(this.key).then((res) => {
        console.log('res', res)
        this.$ls.set('stsToken', res.stsToken)
      })

      this.visible = true
    },
    introRules(rule, value, callback) {
      if (!value) {
        callback('请输入简介')
      } else if (value.trim().length === 0) {
        callback('请输入正确的简介')
      }
      callback()
    },
    //数据回显
    dataBack() {
      const data = {
        ...this.state,
      }
      if (data.degreeCertificatList && data.degreeCertificatList.length) {
        data.degreeCertificatList = data.degreeCertificatList
          .map((item) => {
            /**
             * 1 是学位
             */
            const photoUrlList = item.teaTeacherInfoDos.filter(
              (item) => item.extType === 1
            ).map(i => i.fileUrl)

            const photoUrl = photoUrlList.length ? photoUrlList[0] : ''
            /**
             * 0 是学历
             */
            const photoUrl2List = item.teaTeacherInfoDos.filter(
              (item) => item.extType === 0
            ).map(i => i.fileUrl)
            const photoUrl2 = photoUrl2List.length
              ? photoUrl2List[0]
              : ''
            return {
              eduBackground: item.description,
              text: item.text,
              photoUrl,
              photoUrlList,
              photoUrl2,
              photoUrl2List
            }
          })
          .filter((item) => {
            return item.photoUrl || item.photoUrl2
          })
        console.log(' data.degreeCertificatList', data.degreeCertificatList)
        this.state.degreeCertificatList = data.degreeCertificatList
        this.addCount++
      }

      if (data.gender == 2) {
        this.form.setFieldsValue({ gender: '女' })
      } else if (data.gender == 1) {
        this.form.setFieldsValue({ gender: '男' })
      }
      if (data.intro == 'undefined') {
        this.state.intro = ''
      } else {
        this.form.setFieldsValue({ intro: data.intro })
      }
      if (data.applyCourseType == 'undefined') {
        this.state.applyCourseType = ''
      } else {
        this.form.setFieldsValue({ applyCourseType: data.applyCourseType })
      }

      if (data.cardBackUrl) {
        this.sourceFileList_cardBackUrl.push(data.cardBackUrl) //身份证反面
      }
      if (data.cardFrontUrl) {
        this.sourceFileList_cardFrontUrl.push(data.cardFrontUrl) //身份证正面
      }
      if (data.protraitPhotoUrl) {
        this.sourceFileList_fullFaced.push(data.protraitPhotoUrl[0].fileUrl) //证件照
      }
      if (data.avatarUrl) {
        this.sourceFileList_avatarUrl.push(data.avatarUrl) //头像
      }
      if (data.talkingVideoUrl) {
        this.reqDesc.talkingVideoUrl = data.talkingVideoUrl[0].fileUrl
        this.sourceFileListTalkingVideoUrl.push(data.talkingVideoUrl[0].fileUrl) //8分钟说课视频
      }
      if (data.healthCertificateUrl && data.healthCertificateUrl.length !== 0) {
        this.reqDesc.healthCertificateUrl = data.healthCertificateUrl.map(
          (item) => {
            return item.fileUrl
          }
        ) //健康证明
      }
      if (data.credentialInfoUrl && data.credentialInfoUrl.length !== 0) {
        this.reqDesc.credentialInfoUrlList = data.credentialInfoUrl.map((item) => {
          return item.fileUrl
        }) //老师资质
      }
      if (data.noCriminalUrl) {
        this.sourceFileList_noCriminalUrl.push(data.noCriminalUrl[0].fileUrl) //无犯罪记录
      }
      if (data.experience && data.experience.length !== 0) {
        this.reqDesc.experience = data.experience.map((item) => {
          return item.fileUrl
        }) //从业经验
      }
    },
    //正面免冠照片
    uploadSuccess_fullFaced(url) {
      if (url.length > 0) {
        this.reqDesc.protraitPhotoUrl = url[0].url
      }
    },
    //头像
    uploadSuccess_headPortrait(url) {
      if (url.length > 0) {
        this.reqDesc.avatarUrl = url[0].url
      }
    },
    //学历证
    uploadSuccess_diploma(url, index) {
      console.log('url', url)
      console.log('index', index)
      if (url.length > 0) {
        this.state.degreeCertificatList[index].photoUrl2 = url[0].url
      } else {
        this.state.degreeCertificatList[index].photoUrl2 = ''
      }
    },
    //学位证
    uploadSuccess_photoUrl(url, index) {
      if (url.length > 0) {
        this.state.degreeCertificatList[index].photoUrl = url[0].url
      } else {
        this.state.degreeCertificatList[index].photoUrl = ''
      }
    },
    //身份证正面
    uploadSuccess_frontIDCard(url) {
      if (url.length > 0) {
        this.reqDesc.cardFrontUrl = url[0].url
      }
    },
    //身份证反面
    uploadSuccess_backIDCard(url) {
      if (url.length > 0) {
        this.reqDesc.cardBackUrl = url[0].url
      }
    },
    //健康证明
    uploadSuccess_health(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.healthCertificateUrl = arr
    },
    //无犯罪记录证明
    uploadSuccess_criminal(url) {
      if (url.length > 0) {
        this.reqDesc.noCriminalUrl = url[0].url
      }
    },
    //老师资质
    uploadSuccess_teacher(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.credentialInfoUrlList = arr
    },
    //从业经验
    uploadSuccess_experience(list) {
      let arr = []
      list.map((item) => {
        arr.push(item.url)
        return arr
      })
      this.reqDesc.experience = arr
    },
    //8分钟说课视频
    uploadVideo(list) {
      this.reqDesc.talkingVideoUrl = list[list.length - 1].url
      this.sourceFileListTalkingVideoUrl.push(this.reqDesc.talkingVideoUrl)
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';
#components-layout-demo-basic {
  text-align: left;
  // height: 100vh;
  // overflow: auto;
  // border: 5px solid red;
}
#components-layout-demo-basic .ant-layout-header {
  background: #0b0b0f;
  color: #ffffff;
  font-size: 24px;
}
::v-deep .ant-modal-footer {
  border-top: 0px solid #e8e8e8;
  .modalButton {
    background-color: #68cc2e;
    color: #fff;
  }
  .modalButton:hover {
    border: #fff;
  }
}
.auditChoice {
  height: 80px;
  padding: 0 250px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .auditChoice-title {
    color: #000;
    font-size: 20px;
    font-weight: 700;
  }
  .auditChoice-choise {
    img {
      width: 40px;
      margin-right: 10px;
    }
    color: #000;
    font-size: 16px;
  }
}
.ant-card {
  border-radius: 20px;
}
.group1 {
  height: 40px;
  padding-left: 30px;
}

.word1 {
  font-size: 24px;
  color: rgba(27, 29, 38, 1);
  line-height: 22px;
}
.header {
  margin: 13px 0 0 6px;
}
.pic1 {
  z-index: 23;
  width: 50px;
  height: 50px;
}
.wrap1 {
  display: inline-block;
  height: 50px;
  vertical-align: middle;
  margin-left: 23px;
  .word3 {
    display: block;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
  }
  .word4 {
    color: rgba(135, 136, 138, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    margin-top: 8px;
  }
}
.box3 {
  z-index: 19;
  width: 100%;
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  align-self: center;
  margin: 37px 20px 40px 10px;
}
.section4 {
  z-index: auto;
  height: 22px;
  margin-bottom: 39px;
}

.mod4 {
  z-index: 79;
  width: 9px;
  height: 20px;
  border-radius: 4.5px 4.5px 4.5px 4.5px;
  background-color: rgba(78, 148, 255, 1);
  margin-top: 1px;
  display: inline-block;
}

.txt1 {
  z-index: 65;
  width: 80px;
  height: 22px;
  display: inline-block;
  overflow-wrap: break-word;
  color: rgba(78, 148, 255, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  line-height: 22px;
  text-align: left;
  vertical-align: top;
  margin-left: 12px;
}

.title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin-right: 20px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.education {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.education-rule {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff7032;
  margin-bottom: 20px;
}
.section18 {
  z-index: 38;
  width: 100%;
  height: 4px;
  background-color: rgba(248, 248, 248, 1);
  align-self: center;
  margin: 10px 0;
}
.card {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.section27 {
  z-index: 35;
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin-top: 40px;
}
.button {
  width: 140px;
  height: 42px;
  margin-left: 24px;
}
.footer {
  text-align: center;
  margin-top: 23px;
}
.remark {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #87888a;
  line-height: 20px;
}

/deep/ .fullFaced .ant-upload {
  width: 160px;
  height: 242px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .fullFaced .ant-spin-nested-loading {
  width: 160px;
}

//背景图
/deep/ .backgroundImage .ant-upload {
  width: 750px;
  height: 250px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .backgroundImage .ant-spin-nested-loading {
  width: 750px;
}
/deep/ .backgroundImage .ant-upload-list-picture-card-container {
  width: 750px;
  height: 250px;
  border: 0;
}
/deep/ .backgroundImage .ant-upload-list-item {
  width: 750px;
  height: 250px;
  border: 0;
}

/deep/ .schoolPermit .ant-upload {
  width: 297px;
  height: 210px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
  .ant-spin {
    width: 50%;
    height: 94%;
  }
}
/deep/ .schoolPermit .ant-spin-nested-loading {
  width: 297px;
}
//头像
/deep/ .headPortrait .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;
  .ant-upload-text {
    display: none;
  }
}
/deep/ .headPortrait .ant-spin-nested-loading {
  width: 160px;
}
//LOGO
/deep/ .LOGO .ant-upload {
  width: 250px;
  height: 250px;
  border: 0;
  .ant-upload-text {
    display: none;
  }
}
/deep/ .LOGO .ant-spin-nested-loading {
  width: 250px;
}
/deep/ .LOGO .ant-upload-list-picture-card-container {
  width: 250px;
  height: 250px;
  border: 0;
}
/deep/ .LOGO .ant-upload-list-item {
  width: 250px;
  height: 250px;
  border: 0;
}
/deep/ .diploma .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;
  .ant-upload-text {
    display: none;
  }
}
/deep/ .diploma .ant-spin-nested-loading {
  width: 160px;
}
/deep/ .frontIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  background: url(/home/frontIDCard.png) no-repeat center;
  background-size: 100% 100%;
  .ant-upload-text {
    display: none;
  }
  .anticon-plus {
    display: none;
  }
  .ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
    left: 33%;
  }
}

/deep/ .backIDCard .ant-upload {
  width: 320px;
  height: 200px;
  border: 0;
  margin-left: 0px;
  background: url(/home/backIDCard.png) no-repeat center;
  background-size: 100% 100%;
  .ant-upload-text {
    display: none;
  }
  .anticon-plus {
    display: none;
  }
}
/deep/ .prove .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}
/deep/ .prove .ant-spin-nested-loading {
  width: 160px;
}
/deep/ .otherMaterialsUrls .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  .ant-upload-text {
    display: none;
  }
}
/deep/ .proveHealth .ant-upload {
  width: 160px;
  height: 160px;
  border: 0;

  /deep/ .ant-upload-list-item-list-type-picture-card {
    width: 160px;
    height: 160px;
    border: 0;
  }
  /deep/ .ant-upload-list-item {
    width: 160px;
    height: 160px;
    border: 0;
  }
  .ant-upload-text {
    display: none;
  }
}
/deep/ .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .fullFaced .ant-upload-list-item {
  width: 160px;
  height: 242px;
  border: 0;
}
/deep/ .fullFaced .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

/deep/ .schoolPermit .ant-upload-list-picture-card-container {
  width: 297px;
  height: 210px;
  border: 0;
}

/deep/ .schoolPermit .ant-upload-list-item {
  width: 297px;
  height: 210px;
  border: 0;
}
/deep/ .otherMaterialsUrls .ant-upload-list-picture-card-container {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .otherMaterialsUrls .ant-upload-list-item {
  width: 160px;
  height: 160px;
  border: 0;
}
/deep/ .otherMaterialsUrls .ant-upload-picture-card-wrapper {
  width: 100%;
}

/deep/ .frontIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}
/deep/ .frontIDCard .ant-spin-nested-loading {
  width: 320px;
}
/deep/ .frontIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}
/deep/ .backIDCard .ant-upload-list-item {
  width: 320px;
  height: 200px;
  border: 0;
}

/deep/ .backIDCard .ant-spin-nested-loading {
  width: 320px;
}
/deep/ .backIDCard .ant-upload-list-picture-card-container {
  width: 160px;
  height: 242px;
  border: 0;
}

/deep/ .btn {
  width: 36px;
  height: 25px;
  font-size: 17px;
  margin-top: 10px;
  vertical-align: bottom;
}

.outer9 {
  z-index: 37;
  width: 130%;
  height: 1px;
  // background-color: #000;
  background-color: #f8f8f8;
  margin-top: 20px;
  margin-bottom: 20px;
}
.view-link {
  display: block;
  text-align: center;
}
.textarea-input {
  width: 692px;
  height: 88px;
}
.ideaImg {
  vertical-align: top;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  display: inline-block;
}
.upload {
  vertical-align: top;
  font-size: 14px;
  font-weight: 400;
  color: #c0c4cc;
  line-height: 22px;
  display: inline-block;
}
.cupload {
  display: inline-block;
}
.audit {
  color: #333333;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  padding: 10px 0;
}
.result {
  padding-top: 10px;
  color: #333333;
  font-weight: 600;
  font-size: 16px;
}
::v-deep .ant-modal-content {
  border-radius: 15px;
}
.record {
  position: absolute;
  right: 10%;
  display: inline-block;
  .record1 {
    font-size: 23px;
    font-weight: 600;
  }
  .record2 {
    text-align: center;
    margin-top: 5px;
    font-size: 14px;
    color: #4e94ff;
  }
}
.in-item {
  // border-bottom: 1px solid #f0f3fb;
  margin-top: 20px;
  padding-bottom: 20px;
  > .key {
    color: rgba(0, 0, 0, 0.85);
    font-size: 20px;
    font-weight: 600;
    span {
      font-size: 18px;
      margin-left: 20px;
    }
  }
  > .value {
    font-size: 14px;
    color: #606266;
    margin-top: 10px;
    .item {
      display: inline-block;
      padding: 10px 0px;
      vertical-align: top;
      > .key {
        display: inline-block;
        width: 120px;
        text-align: right;
        font-size: 14px;
        color: #606266;
      }
      > .value {
        color: #35383e;
        font-size: 14px;
        font-weight: 500;
        > img {
          vertical-align: top;
          width: 160px;
          height: 90px;
        }
      }
      > img {
        width: 320px;
        height: 180px;
        vertical-align: top;
        margin-right: 16px;
      }
    }
    .item-33 {
      width: 33%;
    }
    .item-40 {
      width: 34%;
    }
    .item-1 {
      width: 100%;
    }
    .item-placeRemark {
      padding-right: 30%;
    }
    .item-intor {
      padding-right: 30%;
      color: #606266 !important;
    }
  }

  .process {
    // width: 900px;
    height: 100%;
    overflow: auto;
    margin-left: 52px;
    margin-top: 19px;
    &-item {
      margin-bottom: 10px;
      padding-left: 87px;

      .operate {
        color: #c0c4cc;
        margin-left: 16px;
      }
      // 审核意见
      .comment {
        color: #333;
        margin-left: 30px;
      }
      // 下载附件
      .download-btn {
        color: #333;
        margin-left: 30px;
        a {
          margin-left: 20px;
        }
      }
    }
    li:before {
      content: '';
      width: 4px;
      height: 4px;
      display: inline-block;
      border-radius: 50%;
      background: #bdbdbd;
      vertical-align: middle;
    }
  }

  // 审核通过颜色
  .exa1 {
    color: #19ca3c;
  }
  // 审核驳回颜色
  .exa2 {
    color: #f95050;
  }
  // 初审、复审颜色
  .exa3 {
    color: #ffa91f;
  }
}
.value-resolve {
  color: #37c847 !important;
}
.value-rejected {
  color: #f54d15 !important;
}
.value-examine {
  color: #ffa91f !important;
}
// ::v-deep .ant-modal-body{

// }
</style>
